<template>
  <div class="col-md-3 col-12">
    <div class="tax-component-wrap">
      <div class="selected-terms">
        <div class="">
          <h4 class="mb-3">סינון לפי:  
            <span class="h4 empty-link" v-if="selectedTerms.length > 0" @click="emptySelectedTerms">הסרת סינונים</span>
          </h4>
        </div>
        <ul class="list-selected-terms">
          <li v-for="( selectedTermObj, index ) in selectedTermsObjects" :key="index">
            <button @click="removeSelectedTerm(selectedTermObj)">{{ selectedTermObj.name }} <span
                class="close"></span></button>
          </li>
        </ul>
      </div>
      <div class="taxonomies-wrap">
        <ul class="list-tax-root accordion" id="termsAccordion">
          <li class="mb-3" v-for="( taxonomy, index ) in filteredTax" :key="index">
            <h4 @click="toggleAccordion(index)"  class="my-2 accordion-title">
              <span>{{ index }}</span>
              <span class="accordion-expander" v-if="isOpen(index)">-</span>
              <span class="accordion-expander" v-else>+</span>
            </h4>
            <ul v-show="isOpen(index)">
              <li v-for="( term ) in taxonomy.slice(0, 5)" :key="term.term_id">
                <div class="input-label">
                  <input type="checkbox" :id="'term-' + term.term_id" :name="'term-' + term.term_id" :value="term.slug"
                    v-model="selectedTerms" @change="updateSelectedTermObjects(term)">
                  <label :for="'term-' + term.term_id">{{ term.name }}</label>
                </div>
              </li>

              <!-- Render additional content for the term -->
              <div v-if="isExpanded(index)">
                <li v-for="( term ) in taxonomy.slice(5)" :key="term.term_id">
                  <div class="input-label">
                    <input type="checkbox" :id="'term-' + term.term_id" :name="'term-' + term.term_id" :value="term.slug"
                      v-model="selectedTerms" @change="updateSelectedTermObjects(term)">
                    <label :for="'term-' + term.term_id">{{ term.name }}</label>
                  </div>
                </li>
              </div>
              <p class="expander lnk-line" v-if="shouldShowButton(index)" @click="toggleDisplayList(index)">
                {{ isExpanded(index) ? 'הצג פחות' : 'אפשרויות נוסופות' }}
              </p>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
  
<script>
import api from '@/api/index';

export default {
  props: {
    filteredTerms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      taxonomies: [],
      filteredTax:[],
      selectedTerms: [],
      selectedTermsObjects: [],
      openAccordions: [], // Array to store the open accordion indexes
      expandedTaxonomies: []
    };
  },
  created() {
      const language = window.__LANGUAGE__;
      console.log('language',language)
  },
  computed: {
    isMobile() {
      const mobileQuery = window.matchMedia('(max-width: 767px)');
      return mobileQuery.matches;
    },
  },
  async mounted() {
    // fetch taxonomies
    await this.fetchTaxonomies() 
    
    // check for terms in url 
    this.fetchUrl() 

    // openAllAccordions
    this.openAllAccordions();

    // check mobile
    if (!this.isMobile) {
      console.log('!mobile')
    }else{
      console.log('mobile')
    }
  },
  watch: {
    selectedTerms(value) {
      console.log('valu term',value)
      console.log('valuE this.selectedTerms',this.selectedTerms)
      // alert('balue')
      
      if (this.selectedTerms.length > 0) {
        this.updateUrl()
      }else{
        // alert('no')
        this.updateUrl()
        this.filterTerms(false)
      }
    },
    filteredTerms(valueTerms){
      // alert('valueTerms')
      if(valueTerms.length>0){
        this.filterTerms(valueTerms)
      }else{
        this.filterTerms(false)
      }
    }
  },
  methods: {
    async fetchTaxonomies() {
      // const language = 'en'
      const language = window.__LANGUAGE__;
      // console.log('language',this.language)
      const endpoint = '/gettax/'
      const postType = 'restaurants'
      let lang = '?lang=' + language
      let query = endpoint + postType + lang

      await api.get(query)
        .then(response => {
          this.taxonomies = JSON.parse(response.data)
          console.log('this.taxonomies',this.taxonomies)

          this.filterTerms(false)
        })
        .catch(error => {
          console.log(error);
        });
    },
    filterTerms(valueTerms){
      const data = this.taxonomies
      console.log(' data',data)
      if (!valueTerms) {
        // alert('no filtered')
        // this.taxonomies = data
        this.filteredTax = this.taxonomies 
      } else {
        // alert('filtered')
        console.log('valueTerms data',valueTerms)
        const filteredData = {};
        // const data = this.taxonomies
        Object.keys(data).forEach(key => {
          const terms = data[key];
          // console.log('valueTerms terms',terms)
          const filteredTermsInArray = terms.filter(term => valueTerms.some(ft => ft.slug === term.slug));
          filteredData[key] = filteredTermsInArray;
        });
        console.log('valueTerms filteredData',filteredData)
        // this.taxonomies = filteredData
        this.filteredTax  = filteredData
      }

    },
    toggleAccordion(index) {
      const isOpen = this.openAccordions.includes(index);
      if (isOpen) {
        // If accordion is already open, close it
        this.openAccordions = this.openAccordions.filter((i) => i !== index);
      } else {
        // If accordion is closed, open it
        this.openAccordions.push(index);
      }
    },
    isOpen(index) {
      return this.openAccordions.includes(index);
    },
    openAllAccordions() {
      const taxArr = Object.entries(this.filteredTax)
      for (let key in taxArr) {
        this.openAccordions.push(taxArr[key][0]);
      }
    },
    shouldShowButton(taxonomyIndex) {
      const termCount = this.filteredTax[taxonomyIndex].length;
      return termCount > 5;
    },
    toggleDisplayList(taxonomyIndex) {
      if (this.isExpanded(taxonomyIndex)) {
        this.expandedTaxonomies = this.expandedTaxonomies.filter(index => index !== taxonomyIndex);
      } else {
        this.expandedTaxonomies.push(taxonomyIndex);
      }
    },
    isExpanded(taxonomyIndex) {
      return this.expandedTaxonomies.includes(taxonomyIndex);
    },
    
    fetchUrl() {
      // update selectedTerms by url part of terms
      const path = window.location.pathname; // Get the current URL path
      const path_fetch = path.replace('/cs-restaurants', '')
      const urlparts = path_fetch.split('/'); // Split the path into an array of parts
      console.log('urlparts',urlparts)
      const uniqueParts = [...new Set(urlparts)]; // Unique array
      const partsToRemove = ['en','cs-restaurants'];
      const parts = uniqueParts.filter(part => !partsToRemove.includes(part) && part !== ''); // Filter out empty parts
      console.log('THEEEE parts',parts)
      if (parts.length > 0) { // do something with url parts
        this.validateUrlTerms(parts)
      } else { // do something with the selected terms
        this.updateUrl()
      }
    },
    validateUrlTerms(parts) {
      
      // convert a non-iterable object into an array
      var TaxonomiesData = Object.entries(this.filteredTax)
      let terms = []
      // Iterate through the selected parts fo find real terms
      for (const part of parts ) {
        // Iterate through the taxonomies
        for (const [key, value] of TaxonomiesData) {
          // Check if the part exists in the current taxonomy
          for (const t of value) {
            // Check if the part exists in the current taxonomy
            if (t.slug.includes(part)) {
              console.log('part',part)
              // update on checkbox check selected terms object 
              if (!this.selectedTermsObjects.some(item => item.term_id === t.term_id)) {
                this.selectedTermsObjects.push(t)
              }
              // validated terms slugs 
              console.log('part this.selectedTerms',this.selectedTerms)
              if (!this.selectedTerms.some(item => item === t.slug)) {
                terms.push(t.slug)
              }
            } else {
              // console.error(`not Matched part '${part}' in taxonomy '${key}'`);
            }
          }
        }
      }

      if (terms.length > 0) { // validated url and upd selected terms
        this.selectedTerms = terms.filter(part => part !== ''); // Filter out empty parts
      } else {
        console.error('not validated');
      }
    },
    updateSelectedTermObjects(term) {
      const termIndex = this.selectedTermsObjects.findIndex(t => t.slug === term.slug);
      if (termIndex > -1) {
        this.selectedTermsObjects.splice(termIndex, 1);
      } else {
        this.selectedTermsObjects.push(term);
      }
      console.log('update this.selectedTermsObjects',this.selectedTermsObjects)
      this.$emit('update-TermsObjects', this.selectedTermsObjects)
    },
    removeSelectedTerm(itemObj) {
      // Remove the selected item from the selected items array
      this.selectedTerms = this.selectedTerms.filter(i => i !== itemObj.slug);
      this.selectedTermsObjects = this.selectedTermsObjects.filter(i => i !== itemObj);
    },
    emptySelectedTerms() {
      this.selectedTerms.splice(0)
      this.selectedTermsObjects.splice(0)
      this.updateUrl()
      this.filterTerms(false)
    },
    updateUrl() {
      const category = []

      if (this.selectedTerms) {
        this.selectedTerms.forEach(term => {
          category.push(term)
        });
      }else{
        let category = []
      }

      console.log('category',category)

      if (category.length > 0) {
        this.$router.push({ path: `/${category.join('/')}` })
      } else {
        this.$router.push({ path: '/' })
      }

      this.$emit('update-url', category)
      this.$emit('update-TermsObjects', this.selectedTermsObjects)
    }
  }
};
</script>

<style scoped>
.tax-component-wrap h4{
  font-weight: 600;
  font-size: 1rem;
}
ul {
  display: block;
  list-style: none;
  padding: 0;
}
ul.accordion > li {
  border-bottom: 1px solid #ccc;
}
li {
  display: inline-block;
}
ul.list-selected-terms {
  margin-top: 15px;
}
ul.list-tax-root {
  border: 0;
}
ul.list-tax-root li {
  padding: 0 0 5px;
  width: 100%;
}
.accordion-title{
  cursor: pointer;
}
.accordion-title span.accordion-expander{
  float: right; 
}
.rtl .accordion-title span.accordion-expander{
  float: left;
}
label {
  margin: 0 10px;
  vertical-align: text-bottom;
  font-weight: 400;
}
button {
  outline: 0;
  border: 0;
  background: #000;
  color: #fff;
  display: inline-block;
  float: right;
  margin: 0 4px 10px;
  padding: 2px 6px;
  -webkit-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.75);
}
button:hover {
  background-color: #070707;
  color: #fff;
}
.close {
  position: relative;
  width: 15px;
  height: 15px;
  display: inline-block;
  top: 6px;
  right: 1px;
  opacity: 1 !important;
}
.close::before,
.close::after {
  position: absolute;
  content: '';
  width: 2px;
  height: 100%;
  background-color: #fff;
  transform: rotate(45deg);
  transform-origin: center;
}
.close::after {
  transform: rotate(-45deg);
}
.empty-link {
  float: right;
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
}
.rtl .empty-link {
  float: left;
}
.empty-link:hover {
  color: #ccc;
}
input[type='checkbox'] {
  accent-color: #000;
}
.lnk-line{
  text-decoration: underline;
  cursor: pointer;
}
.expander{
  font-weight: 600;
}
</style>
